import Vue from 'vue';
//@ts-ignore
import VueTheMask from 'vue-the-mask';

Vue.use(VueTheMask);
